import React from "react";

const Button = ({ className = "log-in-button", style = null, label = 'uhsfknsuhw', onClick, disabled = false, isLoading = false }) => {
  return (
    <button
      className={className}
      style={{
        ...style,
        backgroundColor: disabled ? '#ccc' : '',
        cursor: disabled ? 'not-allowed' : 'pointer',
        border: disabled ? '1px solid #ccc' : '1px solid #08BD80',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px'
      }}
      title={label}
      onClick={onClick}
      disabled={disabled || isLoading}
    >
      {isLoading && (
        <span 
          className="button-loader" 
          style={{
            width: '16px',
            height: '16px',
            border: '2px solid #ffffff',
            borderBottomColor: 'transparent',
            borderRadius: '50%',
            display: 'inline-block',
            animation: 'rotation 1s linear infinite'
          }}
        />
      )}
      {label}
    </button>
  );
};

export default Button;

